import request from "@/axios";
import { download } from '@/axios/request'
// 获取注销用户列表
export const getCancelUserList = (params) => {
  return request({
    url: "/lebo-user/web/user/cancel/page",
    method: "get",
    params
  });
};

// 解除注销
export const removeCancel = (uuid) => {
  return request({
    url: `/lebo-user/web/user/cancel/removeCancel?uuid=${uuid}`,
    method: "get"
  });
};

// 注销确认
export const confirmCancel = (uuid) => {
  return request({
    url: `/lebo-user/web/user/cancel/confirmCancel?uuid=${uuid}`,
    method: "post",
  });
};

/** 获取客户端类型 */
export const getClientType = () => {
  return request({
    url: "/lebo-system/dict-biz/list",
    method: "get",
    params: {
      code: "client_types"
    }
  });
};

/** 系统字典获取注册方式描述 */
export const getRegType = () => {
  return request({
    url: "/lebo-system/dict/dictionary?code=reg_type",
    method: "GET"
  });
};

export const exportCancelUserList = (data) => {
  download('/lebo-user/web/user/cancel/exportExcel', data)
}

